var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('input',{attrs:{"type":"file","id":"fileUpload","accept":"audio/mp3"},on:{"change":_vm.input}})])}
var staticRenderFns = []

export { render, staticRenderFns }